import { Event } from '@/event-bus/event';

export class MassEditCollapsedEvent extends Event<void> {}
